// Domain types for the Admin Currencies MSPA.

// The currency_type enum, mirrored from the Rails `Currency` model. The label
// is what both the list table and the form's Format dropdown display.
export const CURRENCY_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: "dollars", label: "Dollars" },
  { value: "euros", label: "Euros" },
  { value: "dirham", label: "Dirham" },
  { value: "francs", label: "Francs" },
  { value: "kroner", label: "Kroner" },
  { value: "pounds", label: "Pounds" },
  { value: "rand", label: "Rand" },
  { value: "rupeeI", label: "Rupee I" },
  { value: "rupeeN", label: "Rupee N" },
  { value: "shekels", label: "Shekels" },
  { value: "won", label: "Won" },
  { value: "yen", label: "Yen" },
];

export const currencyTypeLabel = (value: string | null | undefined): string =>
  CURRENCY_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? value ?? "";

// A row in the currencies list table.
export interface Currency {
  id: string;
  name: string;
  currencyType: string;
  conversionRate: number | null;
  default: boolean;
}

// Controlled values for the currency create/edit form.
export interface CurrencyFormValues {
  name: string;
  currencyType: string;
  conversionRate: number | null;
  default: boolean;
}

export const emptyCurrencyForm: CurrencyFormValues = {
  name: "",
  currencyType: "",
  conversionRate: null,
  default: false,
};
